import React from 'react'
import './SidebarLogo.css'

const SidebarLogo = () => {
  return (
    <div className="SidebarLogo_container">
      <img
        className="SidebarLogo_image"
        src="/img/dpdash.png"
        alt="dpdash logo"
      />
    </div>
  )
}

export default SidebarLogo
